<template>
  <div id="app" style="height: 100%;width: 100%" >
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components:{},
  created(){
    window.sys_app = this;
    window.onresize = this.winResize;
    window.addEventListener("resize",this.resize)
  },
  beforeDestroy() {
    window.removeEventListener("resize",this.resize)
  },
  data(){
    return {

    }
  },
  methods:{
    winResize(){
      this.$bus.emit("winresize");
    },

    resize(){
      this.$bus.emit('sys_window_resize')
    },

  }
}
</script>

<style>
/*通用样式引用*/
@import "../node_modules/mapbox-gl/dist/mapbox-gl.css";
@import "../node_modules/@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
@import "./assets/font/font.css";

/*为了防止弹窗的时候地图右侧有17px的空白，由于el-popup-parent--hidden的padding-right:17导致*/
.el-popup-parent--hidden{
 padding-right: 0!important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
  width: 100%;
  height: 100%;
  background-color: #02121F;
}

/*地图比例尺颜色*/
.mapboxgl-ctrl-scale{
  background-color: rgba(255,255,255,0.9)!important;
}

</style>

<style lang="scss">
  .card_box {
    width: 884px;
    height: 673px;
    position: absolute;
    z-index: 10;
    top: 150px;
    left: calc(50% - 442px);
    background-image: url("./../static/img/common/card_background.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 9px 4px 13px 4px;

    .card_title_box {
      width: 100%;
      height: 50px;
      line-height: 47px;
      text-align: center;
      position: relative;
      background-image: url("./../static/img/common/title_card_background.png");
      background-size: 100% 100%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #1BD7FF;

      .card_close_btn {
        width: 17px;
        height: 17px;
        position: absolute;
        cursor: pointer;
        top: 16px;
        right: 20px;
        background-image: url("./../static/img/common/card_close.png");
        background-size: 100% 100%;
      }
      .card-to-max{
        width: 17px;
        height: 17px;
        position: absolute;
        cursor: pointer;
        top: 15px;
        right: 50px;
        color: rgb(1,196,246);
        display: flex;
      }
    }
    .card_body_box{
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      height: calc(100% - 50px);
      position: relative;
      .el-scrollbar {
        .el-scrollbar__wrap {
          overflow-x: hidden; // 隐藏横向滚动栏
          margin-bottom:0!important;
        }
      }
    }
  }
  .card_background_image{
    background-image: url("./../static/img/common/card_background.png") !important;
  }
  .card_title_background_image{
    background-image: url("./../static/img/common/title_card_background.png");
  }

  .sys_sbzt_image{
    background-image:url('./../static/img/common/water2.png');
    background-size: 100% 100%
  }

  .sys_sbztlx_image{
    background-image:url('./../static/img/common/u220.png');
    background-size: 100% 100%
  }

  .sys_radio_dp_group{
    .el-radio-button__inner{
      color: rgba(149, 182, 238, 1)!important;
      font-weight: normal!important;
      background-color: transparent!important;
      background-size: 100% 100% !important;
      background-image: url("../static/image_sys/gysytzt_image/tab-未选.png") !important;
      border: 1px solid rgba(62, 108, 187, 1)!important;
      box-shadow:0 0 0 0 rgba(0,0,0,0) !important;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      color: #ffffff!important;
      font-weight: bold!important;
      background-color: transparent!important;
      background-size: 100% 100% !important;
      background-image: url("../static/image_sys/gysytzt_image/tab-选中.png") !important;
      border: 1px solid #3E6CBB!important;
      box-shadow:0 0 0 0 rgba(0,0,0,0) !important;
    }
    &:first-child .el-radio-button__inner{
      border-color:  rgba(62, 108, 187, 1) !important;
      border-width: 1px !important;
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue